
import Vue from 'vue'

const getDefaultState = () => {
    return {
        inspection: {
          id: 0,
          description: '',
        },
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async GetById( { commit }, idInspection) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`inspection-reason/${idInspection}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                const inspectionResponse = result.data;

                commit('saveState', inspectionResponse);

                return inspectionResponse;
            }
            else {
                return false
            }
        }
        catch(ex) {
            console.log("Error to get inspection", ex);
            return false;
        }
    },

    async List() {

        try {

            const result = await Vue.prototype.$vanKirkApi.get("inspection-reason/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listInspectionReason = result.data.result;
                return listInspectionReason;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list inspection: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, inspectionRequest) {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`inspection-reason/create-update`, inspectionRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let msg = "Register updated with success!";

                if (inspectionRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    inspectionResponse: result.data.result,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },
    
    async Delete(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.delete(`inspection-reason/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                return {
                    success: true,
                    message: "Register deleted with success!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to delete the register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to delete the register: [${error}]`
                };
            }
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.inspection, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.inspection;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
